<template>
    <div id="images">
        <div class="images-popup" v-if="showSlide"></div>
        <div class="images-main" v-if="images" v-click-outside="closeCarousel">
            <div class="images" :class="{mobile: $vuetify.breakpoint.xs}">
                <div v-for="(image, i) in images" :key="i">
                    <div class="image-flex" >
                        <img @click="selectImage(i)" class="image-size" :class="{mobile: $vuetify.breakpoint.xs}" :src="image">
                        <DeleteItem @deleteItem="deleteImage(image)" :images="true"/>
                    </div>
                </div>
            </div>
            <vue-image-lightbox-carousel
                ref="lightbox"
                :show="showSlide"
                @close="showSlide = false"
                :images="slides"
            />
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import DeleteItem from '../popups/DeleteItem'
import VueImageLightboxCarousel from 'vue-image-lightbox-carousel'
export default {
    name: 'Images',
    components: {
        DeleteItem,
        VueImageLightboxCarousel,
    },
    data() {
        return {
            slide: 0,
            showSlide: false,
        }
    },
    props: ['images'],
    computed: {
        slides() {
            return this.images.map((el) => ({path: el}))
        }
    }, 
    methods: {
        selectImage(i) {
            this.showSlide = true
            this.slide = i
        },
        closeCarousel() {
            this.showSlide = false
        },
        deleteImage(image) {
            this.$emit('deleteImage', image)
        }
    },
    directives: {
        ClickOutside
    },
    mounted() {
        if (this.$vuetify.breakpoint.xs) {
            document.querySelector("#images > div > div.modal-mask > div > div.vue-lightbox-content").style.marginBottom = "0px"
        }
    }

}
</script>

<style lang="scss" scoped>
    .image-full{
        max-width: 50%;
    }
#images {
    .images-popup {
            background: rgba(102, 102, 102, 0.5);
            width: 100%;
            height: 100%;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 10;
        }
    .images-main {
        .images {
            display:flex;
            flex-wrap: wrap;
            &.mobile {
                flex-wrap: nowrap;
                overflow-x: auto;
                overflow-y: hidden;
                -ms-overflow-style: -ms-autohiding-scrollbar;
                -webkit-overflow-scrolling: touch;
                white-space: nowrap;
                &::-webkit-scrollbar {
                    display: none;
        }
            }
            .image-flex {
                margin:15px;
                cursor: pointer;
                position: relative;
                &:hover {
                    opacity: 0.8;
                }
                .image-size {
                    width: 100px;
                    height: 100px;
                    &.mobile {
                       width: 75px;
                       height: 75px; 
                    }
                }
            }
        }
        .carousel {
            position:fixed;
            margin:auto;
            top: 150px;
            right: 0;
            left: 0;
            width: 519px;
            height: 594px;
            max-width: 100vw;
            background: black;
            mix-blend-mode: normal;
            border-radius: 16px;
            z-index:10;
        }
    }
}
</style>

<style lang="scss">
// .v-application .v-application--wrap{
//     min-height: auto;
// }
</style>